import { v1 as uuid } from "uuid"

export default (): string => uuid()
